import { render, staticRenderFns } from "./archiveSkills.vue?vue&type=template&id=689fe6d4&scoped=true"
import script from "./archiveSkills.vue?vue&type=script&lang=js"
export * from "./archiveSkills.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689fe6d4",
  null
  
)

export default component.exports